import React from 'react';
import PeopleIcon from '@material-ui/icons/People';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import MovieFilter from '@material-ui/icons/MovieFilter';
import Dialpad from '@material-ui/icons/Dialpad';
import BluetoothIcon from '@mui/icons-material/Bluetooth';
import HomeOutlined from '@material-ui/icons/HomeOutlined';
import LiveHelpOutlined from '@material-ui/icons/LiveHelpOutlined';
//import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

export const items = [
  { href: '/dashboard', icon: <HomeOutlined />, text: 'Home' },
  { href: '/objects', icon: <FolderOpenIcon />, text: 'Collection' },
  { href: '/qrcode', icon: <Dialpad />, text: 'LifeCodes' },
  { href: '/media', icon: <MovieFilter />, text: 'Media' },
  { href: '/beacons', icon: <BluetoothIcon />, text: 'Connections' },
  //{ href: "/analytics", icon: <BarChartIcon />, text: "Analytics" },
  //{ href: "/channels", icon: <DeviceHubIcon />, text: "Channel Settings" },
  { href: '/help', icon: <LiveHelpOutlined />, text: 'Help Center' },
  { href: '/user/edit', icon: <PeopleIcon />, text: 'Account Settings' },
  // { href: '/integrations', icon: <ChevronLeftIcon />, text: 'Integrations' },
];
